import React from "react";
import {
  UserGroupMutationForm,
  GroupDropdown
} from "routes/Manage/DeviceUsers/Shared/Forms";
import { UserGroup } from "generated/graphql";

export const AddUsersModal: React.FC<{
  tenantId: string;
  deviceUsers: Array<{ name: string; id: string }>;
  groupData?: Pick<UserGroup, "name" | "id">;
  urlEndPath: string;
  showLinkOnSuccess: boolean;
}> = ({ tenantId, deviceUsers, groupData, urlEndPath, showLinkOnSuccess }) => {
  return (
    <UserGroupMutationForm
      tenantId={tenantId}
      title="ADD_TO_EXISTING_GROUP"
      description={
        groupData
          ? "ADD_TO_USER_GROUP_DETAILS_ABRV"
          : "ADD_TO_USER_GROUP_DETAILS"
      }
      mutationResultKey="DEVICE_USER_WILL_BE_ADDED_TO_GROUP"
      urlEndPath={urlEndPath}
      deviceUsers={deviceUsers}
      initialGroupData={groupData}
      GroupDropdown={groupData ? undefined : GroupDropdown}
      operation="Add"
      successMessage="ADD_TO_USER_GROUP_SUCCESS"
      showLinkOnSuccess={showLinkOnSuccess}
      errorMessage="UPDATE_GROUP_FAILURE"
    />
  );
};
